import React, { Component } from 'react'
import { Menu, Segment, Image } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { CONFIGURATIONS_PATH, VERSIONS_PATH } from '../config/routes/paths'
import SelectEnvironment from './select-environment'
import { environments } from '../../common/environment-configs'
import PropTypes from 'prop-types'
import logo from '../assets/jason.png'

class AppMenu extends Component {
  state = { env: environments.LOCAL }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  render () {
    if (!this.props.isAuthenticated) {
      return null
    }
    const { activeItem } = this.state
    return (
      <Segment inverted>
        <Menu style={{ height: '70px' }} inverted stackable tiny>
          <Menu.Item as={Link} to={CONFIGURATIONS_PATH}>
            <Image
              src={logo} style={{ height: '85px' }} fluid
            />
            MECHANIC
          </Menu.Item>
          <Menu.Item
            as={Link} to={CONFIGURATIONS_PATH}
            name='configurations'
            active={activeItem === 'configurations'}
            onClick={this.handleItemClick}
          >
            Configurations
          </Menu.Item>
          <Menu.Item
            as={Link} to={VERSIONS_PATH}
            name='versions'
            active={activeItem === 'versions'}
            onClick={this.handleItemClick}
          >
            Versions
          </Menu.Item>
          <Menu.Menu position='right'>
            <Menu.Item>
              <SelectEnvironment />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      </Segment>

    )
  }
}
AppMenu.propTypes = {
  isAuthenticated: PropTypes.bool
}

export default AppMenu
